'use strict';

// Import Libraries
import React from 'react';
import classNames from 'classnames';
import { CSSTransition }  from 'react-transition-group';

export default class ButtonRibbon extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showBack: false,
      showNext: false,
      loaderNavIndexShown: 0
    }

    this.updateChevrons = this.updateChevrons.bind(this);
    this.slideLeft      = this.slideLeft.bind(this);
    this.slideRight     = this.slideRight.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateChevrons);

    this.updateChevrons();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateChevrons);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.children !== this.props.children) {
      this.updateChevrons();
    }
  }

  render() {
    const Tag = this.props.tag || 'div';

    const className =
      classNames('button-ribbon d-flex position-relative', this.props.className, {
        'button-ribbon-trim-edges': !!this.props.trimEdges,
        'button-ribbon-gradient': !!this.props.gradient
      });

    return (
      <Tag className={className} role={this.props.role} tabIndex={this.props.tabIndex}>
        { this.renderBackChevron() }

        <div
          className="buttons d-flex w-100"
          id={this.props.id}
          key={this.props.id}
          ref={ref => this.ribbon = ref}
          role="tablist"
          onScroll={this.updateChevrons}
          >
          { this.props.children }
        </div>

        { this.renderNextChevron() }
      </Tag>
    );
  }

  renderBackChevron() {
    return (
      <CSSTransition in={ this.state.showBack }
                     timeout={ 200 }
                     classNames="slide">
        <div className={classNames('chevron-wrapper left h-100 position-absolute', { hide: !this.state.showBack })}>
          <button
            aria-label="Scroll left"
            className="btn btn-link chevron h-100 m-0 border-0"
            onClick={this.slideRight}
          >
            <i aria-hidden="true" className="fas fa-chevron-left" />
          </button>
        </div>
      </CSSTransition>
    );
  }

  renderNextChevron() {
    return (
      <CSSTransition in={ this.state.showNext }
                     timeout={ 200 }
                     classNames="slide">
        <div className={classNames('chevron-wrapper right h-100 position-absolute', { hide: !this.state.showNext })}>
          <button
            aria-label="Scroll right"
            className="btn btn-link chevron h-100 m-0 border-0"
            onClick={this.slideLeft}
          >
            <i aria-hidden="true" className="fas fa-chevron-right" />
          </button>
        </div>
      </CSSTransition>
    );
  }

  updateChevrons() {
    this.setState(() => {
      const { scrollLeft, offsetWidth, scrollWidth } = this.ribbon;

      return {
        showBack: scrollLeft > 0,
        showNext: (offsetWidth + scrollLeft) < scrollWidth
      };
    });
  }

  slideLeft() {
    const scrollLeft = this.props.loaderNav ? this.calculateOffset(1) : this.ribbon.scrollLeft + this.ribbon.offsetWidth;

    $(this.ribbon).animate({ scrollLeft }, 200);
  }

  slideRight() {
    const scrollLeft = this.props.loaderNav ? this.calculateOffset(-1) : this.ribbon.scrollLeft - this.ribbon.offsetWidth;

    $(this.ribbon).animate({ scrollLeft }, 200);
  }

  calculateOffset(plusOrMinus) {
    let elementSum = 0,
        scrollLeft;

    for( let i = this.state.loaderNavIndexShown; i >= 0 && i < this.ribbon.children.length; i += plusOrMinus) {
      if (elementSum + $(this.ribbon.children[i]).outerWidth() > this.ribbon.offsetWidth - $(this.ribbon.children[i]).outerWidth()) {
         scrollLeft = this.ribbon.scrollLeft + plusOrMinus *  elementSum;
         this.setState({ loaderNavIndexShown: i });
         break;
      } else {
        elementSum += $(this.ribbon.children[i]).outerWidth();
      }
    }

    return scrollLeft;
  }
}
